<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent>
           <el-form-item label="状态：">
                <el-select v-model="searchForm.disposeState" clearable>
                    <el-option v-for="item in pkgStateOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
         <el-form-item label="申请产品：" prop="shopId">
                    <el-select v-model="searchForm.shopId" clearable>
                        <el-option v-for="item in haokaList" :value="item.id" :key=" item.name" :label="item.name"></el-option>
                    </el-select> 
                </el-form-item>
            <el-form-item label="代理商名称：">
                <el-input v-model.trim="searchForm.agentName" clearable></el-input>
            </el-form-item>
             <el-form-item label="收货手机号：">
                <el-input v-model.trim="searchForm.takePhone" clearable></el-input>
            </el-form-item> 
            <el-form-item label="第三方单号：">
                <el-input v-model.trim="searchForm.orderNo" clearable></el-input>
            </el-form-item>
            <el-form-item label="我方单号：">
                <el-input v-model.trim="searchForm.id" clearable></el-input>
            </el-form-item>
 <el-form-item label="输入验证：">
                <el-input v-model="searchForm.myPass" clearable></el-input>
            </el-form-item>
  <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
             <!-- <el-form-item label="产品状态：">
                <el-select v-model="searchForm.upType" clearable>
                    <el-option label="产品已上架" value="1"></el-option>
                    <el-option label="产品已下架" value="2"></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item class="btnArea">
                <el-button type="warning" icon="el-icon-search" @click="getPkgListPageHandle">搜索查询</el-button>
                <el-button type="success"  @click="exportSimInfoHandle" plain icon="el-icon-download">导出Excel</el-button>
               <el-button type="warning" plainicon="el-icon-s-ticket" class="onlyBtn" @click="showBatchChgStateHandler12()">手动更新订单</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >     
            <el-table-column type="index" label="序号" align="center"></el-table-column>  
            <el-table-column label="商品名称" width="300px">
                <template slot-scope="scope">
                    <el-row>
                        <el-col :span="8">
                            <img :src="getImgUrl() +  scope.row.shopImg" width="60" height="60" class="head_pic"/>
                        </el-col>
                        <el-col :span="16">
                            <div style="color:#409EFF;font-size:14px;cursor: pointer; white-space: normal;word-break: break-all; overflow: hidden;" @click="ditailsHeadle(scope.row)" >{{scope.row.shopName}}</div>
                            <div>
                                <span  v-show="scope.row.id"> 订单号：{{scope.row.id}}</span>
                            </div>
                             订单时间：{{scope.row.createTime}}
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>    
            <el-table-column prop="agentName" label="所属代理商"  align="center"></el-table-column>
            <el-table-column prop="takeNickname" label="收货人姓名"  align="center"></el-table-column >
            <el-table-column prop="takePhone" label="手机号"  align="center"></el-table-column>   
                   <el-table-column prop="idCard" label="身份证"  align="center">
                  <template slot-scope="scope">
                      <div style=" white-space: normal;word-break: break-all; overflow: hidden;">{{scope.row.idCard}}</div>
                  </template>
            </el-table-column>
            <el-table-column prop="takeInfos" label="收货地址"  align="center">
                  <template slot-scope="scope">
                      <div style=" white-space: normal;word-break: break-all; overflow: hidden;">{{scope.row.takeInfos}}</div>
                  </template>
            </el-table-column>
                <el-table-column  align="center"  label="处理状态">
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.disposeState==4|| scope.row.disposeState==5" class="item" effect="dark" :content="scope.row.disposeRemark">
                        <p style="color:#409EFF"> {{scope.row.disposeStateName}}</p>
                    </el-tooltip>
                  <el-tooltip v-else-if="scope.row.disposeState==7||scope.row.disposeState==8" class="item" effect="dark" :content="scope.row.disposeRemark">
                        <p style="color:red"> {{scope.row.disposeStateName}}</p>
                    </el-tooltip>
                    <el-tooltip v-else class="item" effect="dark" :content="scope.row.disposeRemark">
                        <p style="color:teal"> {{scope.row.disposeStateName}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column> 
                     <el-table-column prop="emsCode" label="快递单号" width="180"  align="center"></el-table-column>   

                      <el-table-column prop="takeInfos" label="处理描述"  align="center">
                  <template slot-scope="scope">
                      <div style=" white-space: normal;word-break: break-all; overflow: hidden;">{{scope.row.disposeRemark}}</div>
                  </template>
            </el-table-column>
           <el-table-column prop="newPhone" label="新手机号"  align="center"></el-table-column>
            <el-table-column label="操作"  width="180">
                <template v-slot="scope" >
                    <el-button  v-if="scope.row.disposeState!=12" type="primary" plain size="small" @click="showEditPkg(scope.row)">处理</el-button>
                     <el-button  v-if="scope.row.disposeState==4||scope.row.disposeState==7||scope.row.disposeState==8" type="primary" plain size="small" @click="showEditPkgs(scope.row)">重新申请</el-button>
                </template>             
            </el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>    
        <el-dialog :append-to-body="true" class="formDialog"  :title="title" :visible.sync="addPkgVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="addOrEditPkgForm" :model="addOrEditPkgForm" label-width="120px">                
                <el-form-item label="我方单号:" prop="id">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.id" disabled clearable></el-input>
                    </el-col>                    
                </el-form-item>
                 
                   <el-form-item label="处理状态：">
                <el-select v-model="addOrEditPkgForm.disposeState" clearable>
                    <el-option v-for="item in pkgStateOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
                <el-form-item label="处理备注:" prop="disposeRemark">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.disposeRemark"  placeholder="必选" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                 <el-form-item label="第三方单号:" prop="orderNo">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.orderNo" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                  <el-form-item label="快递单号:" prop="emsCode">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.emsCode" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                 <el-form-item label="号卡号码:" prop="newPhone">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.newPhone" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                 
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEidtPkgHandle">确 定</el-button>
            </div>            
        </el-dialog>


<el-dialog :append-to-body="true" class="formDialog"  :title="title" :visible.sync="addPkgVisibales" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="dataFrom" :model="dataFrom" label-width="120px">                
                <el-form-item label="商品名称:" prop="shopName">
                    <el-col :span="22">
                        <el-input v-model.trim="dataFrom.shopName" disabled clearable></el-input>
                    </el-col>                    
                </el-form-item>
                 
                <el-form-item label="姓名:" prop="takeNickname">
                    <el-col :span="22">
                        <el-input v-model.trim="dataFrom.takeNickname"  placeholder="必选" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                 <el-form-item label="手机号:" prop="takePhone">
                    <el-col :span="22">
                        <el-input v-model.trim="dataFrom.takePhone" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                  <el-form-item label="身份证号:" prop="idCard">
                    <el-col :span="22">
                        <el-input v-model.trim="dataFrom.idCard" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                 <el-form-item label="省市区:" prop="pcaAddress">
                    <el-col :span="22">
                        <el-input v-model.trim="dataFrom.pcaAddress" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                 <el-form-item label="详细地址:" prop="takeAddress">
                    <el-col :span="22">
                        <el-input v-model.trim="dataFrom.takeAddress" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                 
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="toReload">确 定</el-button>
            </div>            
        </el-dialog>

        <el-dialog :append-to-body="true" class="formDialog"  title="详情" :visible.sync="detailsShow" width="600px" @close="detailsShowChange" :close-on-click-modal="false">
            <el-form ref="orderInfos" :model="orderInfos" label-width="120px">  
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="商品名称:">{{orderInfos.shopName}}</el-form-item>
                    </el-col>
                   <el-col :span="12" >
                        <el-form-item label="正面照:">
                            <el-image  v-if="orderInfos.headImg" style="width: 150px; height: 150px" :src="getImgUrl() +  orderInfos.headImg"  :preview-src-list="[getImgUrl() +  orderInfos.headImg]" />
                            <span v-else>暂无商品图</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="身份证反面:">
                            <el-image  v-if="orderInfos.backImg" style="width: 150px; height: 150px" :src="getImgUrl() +  orderInfos.backImg"  :preview-src-list="[getImgUrl() +  orderInfos.backImg]" />
                            <span v-else>暂无商品图</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="身份证正面：:">
                            <el-image  v-if="orderInfos.frontImg" style="width: 150px; height: 150px" :src="getImgUrl() +  orderInfos.frontImg"  :preview-src-list="[getImgUrl() +  orderInfos.frontImg]" />
                            <span v-else>暂无商品图</span>
                        </el-form-item>
                    </el-col>
                </el-row> 
            </el-form>             
            <div slot="footer" class="dialog-footer">
                <el-button @click="detailsShowChange">取 消</el-button>
            </div>            
        </el-dialog>


        <el-dialog :append-to-body="true"  title="推广链接" :visible.sync="shareImgs" width="700px" @close="cancel" :close-on-click-modal="false">
            <div style="text-align: center; padding: 10px 0; color: #F56C6C;">注：请保存以下二维码进行推广商品，商品推广后 可在客服管理->申请列表里面查询</div>
            <div style="text-align: center; width:100%;">               
                <img  :src="getImgUrl() +  addOrEditPkgForm.shareImg" alt="" width="300px" height="300px" style="margin: 0 auto;">  
            </div>
            <div style="text-align: center; padding: 10px 0; color: #F56C6C;">推广链接  {{urls}}</div>
            <div slot="footer" class="dialog-footer">
                <el-button type="danger" @click="copy()" class="copy_url" :data-clipboard-text="urls">复制链接</el-button>
                <el-button type="danger" @click="openLink()">打开链接</el-button>
            </div>            
        </el-dialog>
          <el-dialog :append-to-body="true"  title="批量更改状态" :visible.sync="batchOptVisible12" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm"   label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel"> 
                    <el-upload ref="upload" :action="uploadUrl('haoka/update/order/state/excel')" :headers="setHeader()" :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="downPdf()">导入模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler12">确 定</el-button>
            </div> 
        </el-dialog>        
    </div>
</template>
<script>
import {getPkgListPage, addPkg, updatePkg, getPkgDetail, changePkgState, adminPkgSort,exportSimInfo} from '@/api/package.js'
import common from '@/utils/common.js'
import Clipboard from 'clipboard';
export default {
    data(){     
        return {
            haokaList:[],
            shareImgs:false,
            frontImgUrl:'',
            existBackImg:false,
            searchForm: {
                disposeState: '',
                takePhone: '',
                shopId: '',
                myPass:'',
                id:'',
                upType:'',
                orderNo:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,
            },            
            pkgTypeOption: [],
            pkgStateOption: [
                {'code':4,'description':'待处理'},
                {'code':5,'description':'物流派送中'},
                  {'code':6,'description':'已签收-等待首充'},
                    {'code':7,'description':'缺少证件信息'},
                      {'code':8,'description':'审核失败'},
                        {'code':9,'description':'已激活'},
                          {'code':12,'description':'佣金已发放'},
            ],
            pkgStatesOption: [
                {'code':0,'description':'上架'},
                {'code':1,'description':'下架'}
            ],
             typeStatesOption: [
                {'code':1,'description':'产品已上架'},
                {'code':2,'description':'产品已下架'}
            ],
            agentStateOption: [
                {'code':1,'description':'允许'},
                {'code':2,'description':'不允许'}
            ],
            supplierOption: [],
            addOrEditPkgForm: {
                shopName:'',
                emsCode:'',
                disposeState:'',
                disposeRemark:'',
                newPhone:'',
                orderNo:'',
                account:'',
                pwd: '',
                supplierName: '',
                pwdkey:'',
                supplierShopName:'',
                htmlType:'',
                yongjingInfo:'',
                shopInfo:'',
                pkgType:'',
                agentPrice:'',
                agentPriceParent:''
                         
            },
            orderInfos:{
                headImg:'',
                backImg:'',
                frontImg:'',
                shopName:''
            },
            unit: 'G',
            currentId: '',
            addFlag: null,
            addPkgVisibale: false,
            pkgGroup: [],
            myPkgGroup: [],
            title: '',
            message:'',
            urls:'',
            batchOptVisible12:false,
            detailsShow:false,
            addPkgVisibales:false,
            dataFrom: {
                shopName:'',
                id: '',
                idCard:'',
                takeNickname: '',
                takePhone: '',
                takeAddress: '',
                pcaAddress: '',//省市区
                headImg: '',
                backImg: '',
                frontImg: '',
               
            },
        }
    },
    methods: {

         showEditPkgs(row){
             for(var key in this.dataFrom){
                this.dataFrom[key] = row[key]
              
            }
            this.addPkgVisibales=true;
        },

        toReload(){
             common.sysRequest('haoka/order/reload', this.dataFrom, 'post').then(res => {
                if(res.data.code == 200){
                    this.getPkgListPageHandle();
                     this.addPkgVisibales=false;
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
         // 点击名称查看详情
        ditailsHeadle(row){
            this.orderInfos.headImg=row.headImg;
            this.orderInfos.backImg=row.backImg;
            this.orderInfos.frontImg=row.frontImg;
            this.orderInfos.shopName=row.shopName;
            this.detailsShow=true;
          
        },
         handleSuccess(res){
            if(res.code == 200){
                this.batchOptVisible12 = false;
                this.getPkgListPageHandle();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
        },
          showBatchChgStateHandler12(){
            this.batchOptVisible12 = true;
        },
        cancel(){
            this.addPkgVisibales=false;
               this.batchOptVisible12 = false;
            this.shareImgs=false;
            this.addPkgVisibale = false;    
            this.$refs.addOrEditPkgForm.resetFields();  
        },
          downPdf(){
            var link = document.createElement('a');
                link.setAttribute('download', '');
                link.href = '../../../doc/订单状态修改模板.xlsx';
                link.click();
        },
        detailsShowChange(){
            this.detailsShow=false
        },
        //直接打开链接
        openLink(){
            window.open(this.urls)
        },
           exportSimInfoHandle(){//导出excel文件
            this.$confirm("您确定要导出订单列表吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {

                 common.deleteSpaceKey(this.searchForm); 
                exportSimInfo(this.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err)); 
            })          
        },
        //复制功能
        copy() {
            var clipboard = new Clipboard('.copy_url')
            clipboard.on('success', e => {
              this.$message.success('复制成功');
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message.success('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        //同步上游套餐
        updateUpPkg(){
            common.sysRequest('pkg/update/up/pkg', null, 'get').then(res => {
                if(res.data.code == 200){
                    this.getPkgListPageHandle();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        numberHandle(e){          
            var reg = /^\d+(\.\d{1,2})?/;
            if(reg.exec(e.target.value)) {
                e.target.value = reg.exec(e.target.value)[0];
            }                  
        },
         sureBatchChgStateHandler12(){ 
            this.$refs.searchForm.validate(valid => {
                if(valid) {           
                    this.$refs.upload.submit();
                }
                this.batchOptVisible12=false;
                 this.$message.success('导入成功！');
               this.getPkgListPageHandle();


            });

        },
        getPkgListPageHandle($event){   
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
                 common.sysRequest('haoka//list/user', data, 'post').then(res => {
                if(res.data.code == 200){
                     common.listCallback(this, res, 'tbpg'); 
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },   
        showAddPkg(){
            this.addPkgVisibale = true;
            this.addFlag = true;
            this.title = '新增商品';
        },



       
        showEditPkg1(row){
            var data = {
                id: row.id
            }
            common.sysRequest('haoka/share/urls', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.addOrEditPkgForm.shareImg=res.data.data.img;
                    this.shareImgs=true;
                    this.urls=res.data.data.url;
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        showEditPkg11(row){
            var data = {
                id: row.id
            }
            common.sysRequest('haoka/share/addree/urls', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.addOrEditPkgForm.shareImg=res.data.data.img;
                    this.shareImgs=true;
                    this.urls=res.data.data.url;
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
       
        showEditPkg(row){
            this.frontImgUrl=true;
            this.addPkgVisibale = true;
            this.addFlag = false;
            this.title = '修改商品';  
            this.currentId = row.id;   
            var data = {
                id: row.id
            }
            this.addOrEditPkgForm.id=row.id;
            this.addOrEidtPkgHandle.shopName=row.shopName;
            this.addOrEidtPkgHandle.newPhone=row.newPhone;
             this.addOrEidtPkgHandle.orderNo=row.orderNo;
              this.addOrEidtPkgHandle.disposeState=row.disposeState;
              this.addOrEidtPkgHandle.emsCode=row.emsCode;
               this.addOrEidtPkgHandle.disposeRemark=row.disposeRemark;
            this.existBackImg=true;
            common.sysRequest("haoka/share/infos", data, 'post').then(res=>{
                var result = res.data.data;
                for(var key in this.addOrEditPkgForm){
                    this.addOrEditPkgForm[key] = result[key]
                }        
            }).catch(err=> console.error(err));
                         
        },
        addOrEidtPkgHandle(){
           common.sysRequest("haoka/update/user", this.addOrEditPkgForm, 'post').then(res=>{
                            if(res.data.code == 200){
                                this.$message.success(res.data.message);
                                this.getPkgListPageHandle();
                                this.addPkgVisibale=false;
                            }else{
                                this.$message.error(res.data.message);
                            }
                        }).catch(err=> console.error(err));
        },
      
        updateSortNo(row){
            //修改排序号
            var data = {
                id: row.id,
                sort: row.sort
            }
            common.sysRequest('app/pc/update/store/sort', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.getPkgListPageHandle();
                }
            })
            
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getPkgListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getPkgListPageHandle();
        },
        //选择套餐组
        whenChoosePagGroup(val){
            for(let index in this.pkgGroup){
                if(this.pkgGroup[index].id == val){
                    this.addOrEditPkgForm.supplierType = this.pkgGroup[index].supplierType;
                }
            }
            if(this.addOrEditPkgForm.supplierType == 66){
                common.sysRequest('external/pkg/list', null, 'get').then(res => {
                    if(res.data.code == 200){
                        this.myPkgGroup = res.data.data.map.pkgs;
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }
            
        }

    },
    created () {
         common.gethaokaList(this, 'haokaList');
        this.getPkgListPageHandle();
        
    }  
}
</script>
<style lang="less" scoped>
.input-with-select .el-input {
    width: 60px;
}
.formDialog{
    ::v-deep .el-dialog{
        .el-dialog__body{
            height:500px;
            overflow: auto;
        }
    }
}
</style>

